var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-avatar',{attrs:{"size":_vm.size}},[(_vm.photo != null)?_c('img',{attrs:{"src":_vm.photo.url}}):_c('img',{attrs:{"src":require("@/assets/user-default.jpg")}})])}
var staticRenderFns = []

export { render, staticRenderFns }